import { render, staticRenderFns } from "./storagelist.vue?vue&type=template&id=0c455250&scoped=true"
import script from "./storagelist.vue?vue&type=script&lang=js"
export * from "./storagelist.vue?vue&type=script&lang=js"
import style0 from "./storagelist.vue?vue&type=style&index=0&id=0c455250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c455250",
  null
  
)

export default component.exports